import axios from 'axios';
import axiosInstance from '../../../_utils/axiosConfig';

let Reservation : any = {};

Reservation.verifyheberReservation = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/hebergement/verify/reservation`, data)
}

Reservation.heberReservation = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/hebergement/send/reservation`, data)
}

Reservation.verifyVoitureRes = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/location/verify/reservation`, data)
}

Reservation.voitureRes = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/location/send/reservation`, data)
}

Reservation.VerifyRestauRes = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/restaurant/verify/reservation`, data)
}

Reservation.restauRes = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/restaurant/send/reservation`, data)
}

Reservation.verifyLoisirRes = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/loisir/verify/reservation`, data)
}

Reservation.loisirRes = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/loisir/send/reservation`, data)
}

Reservation.verifyCultureRes = async (data:any)=>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/culture/verify/reservation`,data)
}

Reservation.cultureRes = async (data:any) =>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/culture/send/reservation`, data)
}

export default Reservation;